<template>
  <div class="comment" :class="{'android': android}">
    <title-bar class="comment_bar">
      <div slot="left" class="cancel">
        <router-link
          :to="{
                    name:'design',
                    query:{
                        project_id:$route.query.project_id,
                        project_name:$route.query.project_name,
                        image_id:$route.query.image_id
                    }
                }"
        >取消</router-link>
      </div>
      <div slot="title">
        <div>评论</div>
        <div class="desc">点击图中任意位置可插入标记</div>
      </div>
    </title-bar>

    <div class="desgin">
      <img class="desgin_img" :src="image.url">
      <v-touch @tap="touchImage">
        <div class="dot_list" :style="{height:imgHeight}">
          <v-touch @tap="dotTouch(item)" v-for="(item,index) in commentsData" :key="index">
            <div
              class="dot"
              :class="{'active':item.selected}"
              :style="{
                                left:item.position_x*100+'%',
                                top:item.position_y*100+'%'
                            }"
            >
              <span class="num">{{item.text}}</span>
            </div>
          </v-touch>
        </div>
      </v-touch>
    </div>
    <div class="input_section clearfix" v-show="inputShow">
      <avatar
        class="reply_avatar"
        :avatar-url="userInfo.avatar"
        :text-avatar="userInfo.name.slice(-1)"
        :color="userInfo.color"
      ></avatar>
      <div class="comment_input border-top">
        <textarea type="text" v-model="contentText" placeholder="写评论"></textarea>
      </div>
      <v-touch @tap="saveComment">
        <div class="save">发送</div>
      </v-touch>
    </div>

    <div class="comment_list" :class="{active:activeComment.id}">
      <ul>
        <li class="border-bottom">
          <div class="comment_user">
            <div class="avator">
              <avatar
                class="small_avatar"
                :avatarUrl="activeComment.user?activeComment.user.avatar:''"
                :text-avatar="activeComment.user?activeComment.user.name.slice(-1):''"
                :color="activeComment.user?activeComment.user.color:''"
              ></avatar>
            </div>
            <div class="name" v-if="activeComment.user">{{ $root.remark.getRemarkName(activeComment.user.id, activeComment.user.name)}}</div>
            <div class="time">{{activeComment.create_time | toTime}}</div>
          </div>
          <div class="content">{{activeComment.content || '无内容'}}</div>
        </li>
        <li class="border-bottom" v-for="(item,index) in activeComment.replies" :key="index">
          <div class="comment_user">
            <div class="avator">
              <avatar
                class="small_avatar"
                :avatarUrl="item.user?item.user.avatar:''"
                :text-avatar="item.user?$root.remark.getRemarkName(item.user.id, item.user.name).slice(-1):''"
                :color="item.user?item.user.color:''"
              ></avatar>
            </div>
            <div class="name" v-if="item.user">{{ $root.remark.getRemarkName(item.user.id, item.user.name) }}</div>
            <div class="time">{{item.create_time | toTime}}</div>
          </div>
          <div class="content">{{item.content || '无内容'}}</div>
        </li>
      </ul>
    </div>

    <div class="reply border-top" :class="{active:activeComment.id}">
      <v-touch @tap="reply">
        <div class="reply_btn">回复</div>
      </v-touch>
    </div>

    <div class="at_list_wrap" :class="{'active':atShow}">
      <at-list @selected="setAt"></at-list>
    </div>

    <div class="reply_wrap" :class="{'active':replyShow}">
      <reply :focus="replyFocus" @cancel="closeReply" @confirm="saveReply"></reply>
    </div>
  </div>
</template>

<script>
import avatar from "@/components/common/Avatar"
import atList from "../At"
import reply from "../reply"
import titleBar from "@/components/layout/TitleBar"

export default {
    components: {
        avatar,
        atList,
        reply,
        titleBar
    },
    props: {
        image: {},
        comments: {
            type: Array
        }
    },
    data() {
        return {
            activeComment: {},
            inputShow: false,
            contentText: "",
            atShow: false,
            replyShow: false,
            replyFocus: false,
            imgHeight: "100%"
        }
    },
    computed: {
        commentsData() {
            return this.comments
        },
        userInfo() {
            return {
                avatar: localStorage.avatar,
                name: localStorage.name,
                color: localStorage.color
            }
        },
        android() {
            return window.system === "android"
        }
    },
    watch: {
        contentText(newval, oldval) {
            this.debounceShowAt(newval, oldval)
        }
    },
    created() {
        this.debounceShowAt = _debounce(this.showAt, 300)
    },
    mounted() {
        this.setImgHeight()
    },
    methods: {
        setImgHeight() {
            let img = document.querySelector(".desgin_img")
            img.onload = () => {
                this.imgHeight = img.offsetHeight + "px"
            }
        },
        showAt(newval, oldval) {
            if (newval.includes(oldval)) {
                if (newval.slice(-1) == "@") {
                    this.atShow = true
                    let textarea = document.querySelector(".comment_input textarea")
                    textarea.blur()
                }
            }
        },
        dotTouch(item) {
            this.activeComment = item
            this.commentsData.forEach(ele => {
                ele.selected = false
            })
            item.selected = true

            if (item.id) {
                this.inputShow = false
                if (isWebview) {
                    Keyboard.hide()
                }
            } else {
                this.showInput()
            }
            event.cancelBubble = true
        },
        showInput() {
            this.inputShow = true

            if (isWebview && system == "ios") {
                Keyboard.shrinkView(true)
            }
            setTimeout(() => {
                let textarea = document.querySelector(".comment_input textarea")
                if (this.contentText.length) {
                    textarea.setSelectionRange(this.contentText.length, this.contentText.length)
                }
                textarea.focus()
            }, 300)
        },
        touchImage(e) {
            if (this.activeComment.id) {
                this.activeComment = {}
            } else if (e.target.className != "num") {
                //打点相关信息
                let imageWidth = document.querySelector(".desgin").offsetWidth
                let imageHeight = document.querySelector(".desgin_img").offsetHeight
                let dotRadius = (1.5 * parseInt(window.rem)) / 2 + 2
                let scrollT = document.querySelector(".desgin").scrollTop
                let barHeight = document.querySelector(".comment_wrap .title_bar").offsetHeight

                //兼容ios全面屏
                let app = document.querySelector("body")
                let appPaddingTop = parseInt(getComputedStyle(app)["paddingTop"])

                let dotInfo = {
                    text: this.commentsData.length + 1,
                    position_x: (e.center.x - dotRadius) / imageWidth,
                    position_y: (e.center.y - barHeight - dotRadius + scrollT) / imageHeight,
                    selected: true,
                    content: ""
                }
                //判断是否是新创建打点
                if (this.commentsData.length) {
                    let lastComment = this.commentsData[this.commentsData.length - 1]
                    if (!lastComment.id) {
                        dotInfo.text = this.commentsData.length
                        this.$emit("change", dotInfo)
                    } else {
                        this.commentsData.forEach(ele => {
                            ele.selected = false
                        })
                        this.$emit("create", dotInfo)
                    }
                } else {
                    this.$emit("create", dotInfo)
                }

                this.showInput()
            } else {
            }
        },
        async saveComment() {
            this.inputShow = false
            if (isWebview) {
                Keyboard.hide()
            }

            let json = {
                comment_id: uuidv4(),
                image_id: this.$route.query.image_id,
                project_id: this.$route.query.project_id,
                p_name: this.$route.query.project_name,
                content: this.contentText,
                team_id: localStorage.teamId,
                text: this.commentsData.length,
                version_id: this.image.versions[0].id,
                width: 0,
                height: 0
            }

            let lastComment = this.commentsData[this.commentsData.length - 1]
            let info = Object.assign(lastComment, json)

            let res = await API.image.addImageComment(info)
            if (res) {
                this.contentText = ""
                let data = res.data.result
                this.$emit("reset", data)
                this.$nextTick(() => {
                    this.dotTouch(this.commentsData[0])
                })
            }
        },
        setAt(name) {
            if (name) {
                this.contentText += name + " "
            }
            this.atShow = false
            this.showInput()
        },
        reply() {
            this.replyShow = true
            this.$nextTick(() => {
                this.replyFocus = true
            })
        },
        closeReply() {
            this.replyShow = false
            this.replyFocus = false
        },
        async saveReply(content) {
            this.replyShow = false
            this.replyFocus = false
            if (isWebview) {
                Keyboard.hide()
            }

            let info = {
                comment_id: uuidv4(),
                image_id: this.$route.query.image_id,
                project_id: this.$route.query.project_id,
                p_name: this.$route.query.project_name,
                content: content,
                team_id: localStorage.teamId,
                version_id: this.image.versions[0].id,
                reply_id: this.activeComment.id
            }

            let res = await API.image.addImageComment(info)

            if (res) {
                let data = res.data.result
                this.$emit("reset", data)

                this.$nextTick(() => {
                    this.updateActiveComment()
                    setTimeout(() => {
                        let list = document.querySelector(".comment_list.active")
                        list.scrollTop = 10000
                    }, 200)
                })
            }
        },
        updateActiveComment() {
            this.commentsData.forEach(ele => {
                if (ele.id == this.activeComment.id) {
                    this.activeComment = ele
                    this.activeComment.selected = true
                }
            })
        }
    },
    filters: {
        toTime: function(val) {
            if (!val) {
                return
            }
            var oDate = new Date(val * 1000)
            oDate.setHours(oDate.getHours() - 8)
            var nowDate = new Date(),
                nowTime = nowDate.getTime(),
                nowHour = nowDate.getHours(),
                createTime = oDate.getTime()

            var disTime = nowTime - nowHour * 60 * 60 * 1000 - createTime
            var day = parseInt(disTime / (24 * 60 * 60 * 1000))
            if (disTime <= 0) {
                var min = oDate.getMinutes()
                if (min < 10) {
                    min = "0" + min
                }
                return oDate.getHours() + ":" + min
            } else if (day < 1) {
                var min = oDate.getMinutes()
                if (min < 10) {
                    min = "0" + min
                }
                return `昨天${oDate.getHours()}:${min}`
            } else if (day < 2) {
                var min = oDate.getMinutes()
                if (min < 10) {
                    min = "0" + min
                }
                return `前天${oDate.getHours()}:${min}`
            } else {
                var date = oDate.getDate()
                if (date < 10) {
                    date = "0" + date
                }
                return `${oDate.getFullYear()}年${oDate.getMonth()}月${date}日`
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.comment {
    &.android{
        padding-top: 3.45rem !important; 
    }
    height: 100%;
    padding-top: 3.35rem; //ios_top
    padding-top: calc(constant(safe-area-inset-top) + 2.35rem);
    padding-top: calc(env(safe-area-inset-top) + 2.35rem);
    box-sizing: border-box;
    .comment_bar {
        position: fixed;
        left: 0;
        top: 0;
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
        .cancel {
            font-size: 0.7rem;
            position: absolute;
            left: 0.7rem;
            top: 50%;
            transform: translate(0, -50%);
            a {
                color: #000000;
            }
        }
        .title {
            .desc {
                font-size: 0.55rem;
                color: #888888;
            }
        }
    }
    .desgin {
        position: relative;
        height: 100%;
        overflow-y: auto;
        img {
            width: 100%;
            display: block;
        }
        .dot_list {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            .dot {
                position: absolute;
                width: 1.5rem;
                height: 1.5rem;
                background: white;
                box-shadow: 0rem 0rem 0.1rem 0rem rgba(0, 0, 0, 0.3);
                text-align: center;
                line-height: 1.5rem;
                font-size: 0.9rem;
                color: white;
                border-radius: 50%;
                overflow: hidden;
                border: 2px solid rgba(255, 255, 255, 0.8);
                .num {
                    display: block;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background: rgba(255, 51, 102, 0.6);
                }
                &.active {
                    border: 2px solid rgba(255, 255, 255, 1);
                    .num {
                        background: rgba(255, 51, 102, 1);
                    }
                }
            }
        }
    }
    .input_section {
        background: white;
        width: 100%;
        position: fixed;
        left: 0;
        bottom: 0;
        padding: 0.5rem 0.6rem;
        padding-bottom: calc(constant(safe-area-inset-bottom) + 0.5rem);
        padding-bottom: calc(env(safe-area-inset-bottom) + 0.5rem);
        box-sizing: border-box;
        // border-top: 1px solid #c9c9c9;
        .reply_avatar {
            width: 2rem;
            height: 2rem;
            font-size: 0.9rem;
            float: left;
            margin-right: 0.5rem;
        }
        .comment_input {
            float: left;
            height: 2rem;
            overflow: hidden;
            border: 1px solid #c9c9c9;
            border-radius: 4px;
            textarea {
                width: 11.5rem;
                height: 2rem;
                border: 1px solid #c9c9c9;
                padding: 0 0.4rem;
                box-sizing: border-box;
                border-radius: 0.3rem;
                font-size: 0.7rem;
                resize: none;
                line-height: 2rem;
            }
            ::placeholder {
                font-size: 0.7rem;
                color: rgba(136, 136, 136, 1);
            }
        }
        .save {
            float: right;
            width: 3rem;
            height: 1.6rem;
            line-height: 1.6rem;
            font-size: 0.8rem;
            background: #2878ff;
            border-radius: 4px;
            color: white;
            text-align: center;
            margin-top: 0.2rem;
        }
        .save:active {
            background: rgb(35, 97, 204);
        }
    }
    .comment_list {
        position: fixed;
        left: 0;
        bottom: -100%;
        z-index: 1111;
        width: 100%;
        max-height: 60%;
        overflow-y: auto;
        background: white;
        box-shadow: 0rem -0.05rem 0.15rem 0rem rgba(200, 200, 200, 0.2);
        padding-bottom: 2.7rem;
        transition: all ease 500ms;
        &.active {
            bottom: 0;
            bottom: constant(safe-area-inset-bottom);
            bottom: env(safe-area-inset-bottom);
        }
        li {
            padding: 0.5rem 0.98rem 0.7rem 0.75rem;
            .comment_user {
                height: 1.45rem;
                line-height: 1.45rem;
                .avator {
                    float: left;
                    margin-right: 0.5rem;
                    width: 1.45rem;
                    height: 1.45rem;
                    .small_avatar {
                        width: 1.45rem;
                        height: 1.45rem;
                        font-size: 0.9rem;
                    }
                }
                .name {
                    float: left;
                    font-size: 0.7rem;
                    color: rgba(34, 34, 34, 1);
                }
                .time {
                    float: right;
                    color: rgba(136, 136, 136, 1);
                    font-size: 0.6rem;
                }
            }
            .content {
                padding-top: 0.7rem;
                color: rgba(136, 136, 136, 1);
                font-size: 0.7rem;
            }
        }
    }
    .reply {
        position: fixed;
        left: 0;
        bottom: -100%;
        background: white;
        width: 100%;
        padding: 0.5rem 0;
        z-index: 1112;
        transition: all ease 500ms;
        &.active {
            bottom: 0;
            padding-bottom: calc(constant(safe-area-inset-bottom) + 0.5rem);
            padding-bottom: calc(env(safe-area-inset-bottom) + 0.5rem);
        }
    }
    .reply_btn {
        margin: 0 auto;
        width: 16.55rem;
        height: 1.8rem;
        line-height: 1.8rem;
        padding-left: 0.6rem;
        font-size: 0.7rem;
        color: rgba(136, 136, 136, 1);
        border: 1px solid #c9c9c9;
        border-radius: 4px;
    }
    .at_list_wrap {
        height: 100%;
        width: 100%;
        position: fixed;
        left: 0;
        top: 100%;
        z-index: 1111;
        transition: all ease 200ms;
        &.active {
            top: 0;
            padding-bottom: constant(safe-area-inset-bottom);
            padding-bottom: env(safe-area-inset-bottom);
        }
    }

    .reply_wrap {
        height: 100%;
        width: 100%;
        position: fixed;
        left: 0;
        top: 100%;
        z-index: 1113;
        transition: all ease 200ms;
        &.active {
            top: 0;
            padding-top: 1rem; //ios_top
            padding-top: constant(safe-area-inset-top);
            padding-top: env(safe-area-inset-top);
        }
    }
}
</style>
